import React from "react";
import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";

export function UiTabs({ variant = "enclosed", colorScheme = "gwbi", ...props }) {
  return <Tabs variant={variant} colorScheme={colorScheme} {...props} />;
}

export function UiTabList(props) {
  return <TabList borderBottomColor="border.default" {...props} />;
}

export function UiTab(props) {
  return <Tab {...props} />;
}

export function UiTabPanels(props) {
  return <TabPanels {...props} />;
}

export function UiTabPanel(props) {
  return <TabPanel {...props} />;
}
